import axios from 'axios'
import { Message } from 'element-ui'
let baseURL = process.env.NODE_ENV == "development" ? '/api' : 'https://www.eonely.com'
// console.log(baseURL, 'baseURLbaseURL', process.env)
// 创建 axios 对象
const instance = axios.create({
    baseURL,
    //baseURL: 'https://wy.sd-wh.com.cn',
    timeout: 50000,
})


// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
instance.interceptors.request.use(function (config) {
    // console.log(baseURL, 'baseURLbaseURL', process.env.BASE_URL, process.env.NODE_ENV)
    config.headers.appVersion = '1.0.1'
    // let token = localStorage.getItem('token')
    // if (token) {
    //     config.headers.token = token
    // }

    return config
}, function (err) {
    return Promise.request(err)
}
)

// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
instance.interceptors.response.use(
    (response) => {
        // console.log(response, '11111撒旦发射点')
        // console.log(response, response.data.status.userMsg, 'response' )  || response.data.status.code == 401
        // response.data.status.code == 401
        // Message.error('所有请求')
        if (response.data.status.code == 400) {
            return response.data
        }
        if (response.headers.newToken) {
            console.log("亲求头", response.headers.newToken)
            localStorage.setItem('token', response.headers.newToken)
            localStorage.setItem('Token', response.headers.newToken)
        }
        return response.data
    },
    (error) => {
        console.log(error, '500')
        Message.error('网络错误，请联系管理员')
        return Promise.reject(error)
    }
)



export default instance;
